// extracted by mini-css-extract-plugin
export default {"uplink":"TA7t","downlink":"yecN","active":"d_pW","icon":"cmt6"};